export const displayOption = {
  DEFAULT_COUNT: 3,
  MAX_COUNT: 23,
} as const
